/**
 * Creates an Error Message object enhancing the Html Validation Error object
 */
export default class InputError {
    static createValidationObject(message) {
        let valObject = InputError.createDefaultValidationObject();
        let valid = true;
        if (message && message.toLowerCase().includes('require')) {
            valObject.valueMissing = true;
            valid = false;
        } else if (message) {
            valid = false;
        }

        valObject.valid = valid;

        return valObject;
    }

    static createDefaultValidationObject() {
        return {
            badInput: false,
            customError: false,
            patternMismatch: false,
            rangeOverflow: false,
            rangeUnderflow: false,
            stepMismatch: false,
            tooLong: false,
            tooShort: false,
            typeMismatch: false,
            valid: true,
            valueMissing: false,
        };
    }

    /**
     * Creates a new instance of the InputError class
     * @param {*} options  the options object having the following properties.
     * @param {Object} options.validationObject  the html5 validation object.
     * @param {String} options.validationMessage  the html5 validation message.
     * @param {String} options.id the control id.
     * @param {String} options.shortName the control's Short Name for display.
     * @param {String} options.parentId the parent control id(if the control is nested).
     * @param {String} options.parentShortName the parent control's Short Name for display.
     */

    constructor(options) {
        this.validationObject = options.validationObject;
        this.validationMessage = options.validationMessage;
        this.id = options.id;
        this.shortName = options.shortName;
        this.parentId = options.parentId;
        this.parentShortName = options.parentShortName;
    }

    get isValid() {
        return this.validationObject.valid;
    }

    get globalMessage() {
        if (this.isValid) {
            return '';
        }

        return `${this.controlName}:  ${this.validationMessage}`;
    }

    get localMessage() {
        if (this.isValid) {
            return '';
        }

        return this.validationMessage;
    }

    get controlName() {
        let name = this.shortName || this.id;

        // is a nested control
        if (this.parentId) {
            name = `${this.parentShortName || this.parentId}.${name}`;
        }

        return name;
    }
}


// WEBPACK FOOTER //
// ./source/framework/core/InputError.js